import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogOverlay,
  AlertDialogPortal,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { Button } from '../../ui/button';

const DeleteConfirmDialog = ({
  onConfirm,
  dialogIsOpen,
  onOpen,
  onClose,
  children,
  title,
  description,
}: {
  onConfirm: () => void;
  dialogIsOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  children?: React.ReactNode;
  title: string;
  description: string;
}) => {
  return (
    <AlertDialog
      open={dialogIsOpen}
      // Map Radix state changes to existing handlers
      onOpenChange={(open) => (open ? onOpen() : onClose())}
    >
      <AlertDialogTrigger asChild>{children}</AlertDialogTrigger>

      <AlertDialogPortal>
        <AlertDialogOverlay />
        <AlertDialogContent className="sm:max-w-[425px]">
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>

          <div className="mt-4 flex justify-end gap-2">
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            {/* Close only after the mutation succeeds*/}
            <Button variant="destructive" onClick={onConfirm}>
              {' '}
              Confirm{' '}
            </Button>
          </div>
        </AlertDialogContent>
      </AlertDialogPortal>
    </AlertDialog>
  );
};

export default DeleteConfirmDialog;
